export default {
  done: false,
  model: {}
}
